'use client';

import { c as _c } from "react/compiler-runtime";
import { Shield } from 'lucide-react';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import { Container, Section, SectionHeader, MotionBlock, ContentCard, CardIconWrap, CardTitle, CardText, PrimaryButton, SectionActions, cardGridClass } from './shared';
export function SecuritySection() {
  const $ = _c(13);
  const c = useCadrinoCopy();
  const pages = useWebsitePagesCopy();
  let t0;
  if ($[0] !== c.security.subtitle || $[1] !== c.security.title) {
    t0 = <MotionBlock><SectionHeader title={c.security.title} subtitle={c.security.subtitle} /></MotionBlock>;
    $[0] = c.security.subtitle;
    $[1] = c.security.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== c.security.items) {
    t1 = c.security.items.map(_temp);
    $[3] = c.security.items;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className={cardGridClass}>{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== pages.nav.security) {
    t3 = <MotionBlock><SectionActions><PrimaryButton href="/security">{pages.nav.security}</PrimaryButton></SectionActions></MotionBlock>;
    $[7] = pages.nav.security;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t0 || $[10] !== t2 || $[11] !== t3) {
    t4 = <Section id="security"><Container>{t0}{t2}{t3}</Container></Section>;
    $[9] = t0;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(item, i) {
  return <MotionBlock key={item.title} delay={i * 0.05}><ContentCard><CardIconWrap><Shield className="h-5 w-5" aria-hidden={true} /></CardIconWrap><CardTitle>{item.title}</CardTitle><CardText className="mt-2 flex-1">{item.description}</CardText></ContentCard></MotionBlock>;
}